var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"spinner-border text-primary",class:{'spinner-border-sm': _vm.small},attrs:{"role":"status","aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }